var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
  '--horizontal-padding': _vm.horizontalPadding,
  '--vertical-padding': _vm.verticalPadding,
  minHeight: _vm.minHeight,
  background: _vm.background,
  color: _vm.color
}),attrs:{"id":"main_footer"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('transition',{attrs:{"name":"fade"}},[(_vm.hitokoto !== null && _vm.hitokoto !== '')?_c('p',[_vm._v(_vm._s(_vm.hitokoto))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }